import { Chain } from "viem/chains";
import { getPublicClient } from "wagmi/actions";
import { Amount } from "../../types/amount";
import { Balance } from "./getBalances";
import { TokenList } from "./getAllTokenLists";
import { Address } from "viem";
import { NATIVE_TOKEN_ADDRESS } from "config/consts";
import { getMulticallResult } from "./getMulticall";

export type Balances = Array<Balance>;

export const fetchBalancesFast = async (
  userAddress: Address,
  tokens: TokenList,
  network: Chain
): Promise<Balances> => {
  if (network && tokens) {
    const publicClient = getPublicClient({ chainId: network.id });
    const nativeTokenBalance = await publicClient.getBalance({ address: userAddress });
    const erc20TokenBalances = await getMulticallResult(tokens, network, "balanceOf", [
      userAddress,
    ]);
    return [
      {
        tokenAddress: NATIVE_TOKEN_ADDRESS,
        balance: new Amount(nativeTokenBalance.toString()).div(new Amount((10 ** 18).toString())),
      },
      ...erc20TokenBalances.map(res => ({ tokenAddress: res.tokenAddress, balance: res.result })),
    ];
  }
  return [];
};
